import {ApiActionLogListResponseDto} from '@birco/rainmesh-api';
import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import { ActionLogFilter } from '../../../features/action-log/state/action-log.state';

export interface ActionLogStateService {

  getActionLog(options: ActionLogFilter): Observable<ApiActionLogListResponseDto>;

}

export const ACTION_LOG_STATE_SERVICE_INJECTION_TOKEN = new InjectionToken<ActionLogStateService>('ActionLogStateService');
